<template>
  <div class="welfare-allowance-container pt-10">
    <a-row :gutter="32">
      <!-- Full Width Content -->
      <a-col :span="24">
        <div class="mb-30">
          <a-row :gutter="32" type="flex" align="middle">
            <a-col :xs="24" :md="16">
              <p class="font-web mb-10 text-dark font-weight-bold">
                ภาพรวมและขั้นตอนการขอรับสวัสดิการเงินช่วยเหลือ ประกอบด้วย ค่าเยี่ยมคลอด ค่าเยี่ยมไข้ โรคร้ายแรง
                และค่าฌาปนกิจสงเคราะห์
              </p>
              <p class="font-web mb-20 text-muted">
                รายละเอียด / Description<br />
                An Overview and Steps for Welfare Allowance: Childbirth, Hospital Visit, Critical Illness and Funeral
              </p>
            </a-col>
            <a-col :xs="24" :md="8" class="text-center">
              <img src="/images/hri_dashboard/walfare/w_1a.png" class="img-fluid rounded mb-10 shadow-sm clickable-img"
                style="max-width: 60%;" alt="Welfare Overview"
                @click="openPreview('/images/hri_dashboard/walfare/w_1a.png')" />
            </a-col>
          </a-row>
        </div>

        <!-- Render Sections 2 to 5 dynamically -->
        <div class="section-block mb-30" v-for="sec in subSections" :key="sec.id">
          <h3 class="section-title">
            {{ sec.title }} {{ sec.keyword }}
            <div class="text-muted" style="font-size: 14px; font-weight: normal; margin-top: 4px;">{{ sec.enTitle }}
            </div>
          </h3>

          <div v-if="sec.keyword === 'WF002'" class="mt-15 mb-20 text-center">
            <img src="/images/hri_dashboard/walfare/Final_TH_Childbirth.png"
              class="img-fluid rounded shadow-sm mb-20 clickable-img" alt="Critical Illness TH"
              style="width: 20%; display: inline-block; margin-right: 4%;"
              @click="openPreview('/images/hri_dashboard/walfare/Final_TH_Childbirth.png')" />
            <img src="/images/hri_dashboard/walfare/Final_EN_Childbirth.png"
              class="img-fluid rounded shadow-sm mb-20 clickable-img" alt="Critical Illness EN"
              style="width: 20%; display: inline-block;"
              @click="openPreview('/images/hri_dashboard/walfare/Final_EN_Childbirth.png')" />
          </div>

          <div v-if="sec.keyword === 'WF001'" class="mt-15 mb-20 text-center">
            <img src="/images/hri_dashboard/walfare/Final_TH_ Hospital.png"
              class="img-fluid rounded shadow-sm mb-20 clickable-img" alt="Hospital TH"
              style="width: 20%; display: inline-block; margin-right: 4%;"
              @click="openPreview('/images/hri_dashboard/walfare/Final_TH_ Hospital.png')" />
            <img src="/images/hri_dashboard/walfare/Final_EN_ Hospital.png"
              class="img-fluid rounded shadow-sm mb-20 clickable-img" alt="Hospital EN"
              style="width: 20%; display: inline-block;"
              @click="openPreview('/images/hri_dashboard/walfare/Final_EN_ Hospital.png')" />
          </div>

          <div v-if="sec.keyword === 'WF004'" class="mt-15 mb-20 text-center">
            <img src="/images/hri_dashboard/walfare/Final_TH_critical.png"
              class="img-fluid rounded shadow-sm mb-20 clickable-img" alt="Critical Illness TH"
              style="width: 20%; display: inline-block; margin-right: 4%;"
              @click="openPreview('/images/hri_dashboard/walfare/Final_TH_critical.png')" />
            <img src="/images/hri_dashboard/walfare/Final_EN_critical.png"
              class="img-fluid rounded shadow-sm mb-20 clickable-img" alt="Critical Illness EN"
              style="width: 20%; display: inline-block;"
              @click="openPreview('/images/hri_dashboard/walfare/Final_EN_critical.png')" />
          </div>

          <div v-if="sec.keyword === 'WF003'" class="mt-15 mb-20 text-center">
            <img src="/images/hri_dashboard/walfare/Final_TH_Funeral.png"
              class="img-fluid rounded shadow-sm mb-20 clickable-img" alt="Funeral TH"
              style="width: 20%; display: inline-block; margin-right: 4%;"
              @click="openPreview('/images/hri_dashboard/walfare/Final_TH_Funeral.png')" />
            <img src="/images/hri_dashboard/walfare/Final_EN_Funeral.png"
              class="img-fluid rounded shadow-sm mb-20 clickable-img" alt="Funeral EN"
              style="width: 20%; display: inline-block;"
              @click="openPreview('/images/hri_dashboard/walfare/Final_EN_Funeral.png')" />
          </div>

          <div v-if="getDocs(sec.keyword).length > 0" class="mt-15">
            <table class="doc-table">
              <thead>
                <tr>
                  <th>รายการไฟล์ / File List</th>
                  <th class="text-center">Download</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(doc, idx) in getDocs(sec.keyword)" :key="idx">
                  <td>
                    <div class="file-name-main">{{ doc.thName }}</div>
                    <div v-if="doc.updatedAt" class="file-date">อัปเดตเมื่อ: {{ formatDate(doc.updatedAt) }}</div>
                  </td>
                  <td class="text-center">
                    <a v-if="doc.thLink" :href="doc.thLink" target="_blank" class="download-link">
                      <a-icon type="download" />
                    </a>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-muted mt-10 italic">ไม่มีเอกสาร (No documents found)</div>
        </div>

        <!-- Other Documents (If any) -->
        <div class="section-block mb-30" v-if="getOtherDocs().length > 0">
          <h3 class="section-title">เอกสารอื่นๆ (Other Documents)</h3>
          <div class="mt-15">
            <table class="doc-table">
              <thead>
                <tr>
                  <th>รายการไฟล์ / File List</th>
                  <th class="text-center">Download</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(doc, idx) in getOtherDocs()" :key="idx">
                  <td>
                    <div class="file-name-main">{{ doc.thName }}</div>
                    <div v-if="doc.updatedAt" class="file-date">อัปเดตเมื่อ: {{ formatDate(doc.updatedAt) }}</div>
                  </td>
                  <td class="text-center">
                    <a v-if="doc.thLink" :href="doc.thLink" target="_blank" class="download-link">
                      <a-icon type="download" />
                    </a>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </a-col>
    </a-row>

    <!-- Image Preview Modal -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false" centered width="60%">
      <img alt="Preview" style="width: 100%; border-radius: 8px;" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({ docs: [] })
    }
  },
  data() {
    return {
      subSections: [
        { id: 1, title: '1. ค่าเยี่ยมคลอด', enTitle: 'Childbirth', keyword: 'WF002' },
        { id: 2, title: '2. ค่าเยี่ยมไข้', enTitle: 'Hospital Visit', keyword: 'WF001' },
        { id: 3, title: '3. โรคร้ายแรง', enTitle: 'Critical Illness', keyword: 'WF004' },
        { id: 4, title: '4. ค่าฌาปนกิจสงเคราะห์', enTitle: 'Funeral', keyword: 'WF003' }
      ],
      previewVisible: false,
      previewImage: ''
    };
  },
  methods: {
    openPreview(imgSrc) {
      this.previewImage = imgSrc;
      this.previewVisible = true;
    },
    getDocs(keyword) {
      if (!this.item || !this.item.docs) return [];
      const searchKeyword = keyword === 'WF004' ? 'WF001' : keyword;
      return this.item.docs.filter(doc => doc.originalName && doc.originalName.includes(searchKeyword));
    },
    getOtherDocs() {
      if (!this.item || !this.item.docs) return [];
      const keywords = this.subSections.map(s => s.keyword);
      return this.item.docs.filter(doc => {
        if (!doc.originalName) return true;
        return !keywords.some(kw => doc.originalName.includes(kw));
      });
    },
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('DD/MM/YYYY HH:mm');
    }
  }
};
</script>

<style scoped>
.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 8px;
}

.section-block {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.text-muted {
  color: #8c8c8c;
}

.text-dark {
  color: #1a1a2e;
}

.font-weight-bold {
  font-weight: 600;
}

.italic {
  font-style: italic;
}

.img-fluid {
  max-width: 100%;
  height: auto;
  display: block;
}

.rounded {
  border-radius: 8px;
}

.shadow-sm {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.sticky-images {
  position: sticky;
  top: 20px;
}

/* Document Table Styles */
.doc-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.doc-table th {
  background: #f8f9fa;
  padding: 12px 15px;
  text-align: left;
  font-weight: 700;
  color: #1a1a2e;
  border-bottom: 2px solid #e8e8e8;
  font-size: 14px;
}

.doc-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
  color: #434343;
  font-size: 14px;
}

.file-name-main {
  font-weight: 600;
  color: #1a1a2e;
  line-height: 1.4;
}

.file-date {
  font-size: 11px;
  color: #bfbfbf;
  margin-top: 4px;
}

.text-center {
  text-align: center;
}

.download-link {
  color: #4285F4;
  font-size: 18px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.download-link:hover {
  color: #1a73e8;
  transform: translateY(-2px);
}

.mt-15 {
  margin-top: 15px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-10 {
  margin-top: 10px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-30 {
  margin-bottom: 30px;
}

.pt-10 {
  padding-top: 10px;
}

.clickable-img {
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.clickable-img:hover {
  transform: scale(1.02);
}
</style>
